import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./AuthCallback.css";
import { API_URL } from "../config";
import {
  getFirebaseAuth,
  getRedirectResult,
} from "../services/firebase";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { updateUser } = useAuth();
  const callbackProcessed = useRef(false);

  const persistSession = (data, profileData) => {
    const userData = {
      email: profileData.email,
      name: profileData.name,
      picture: profileData.picture,
      subscription_type: profileData.subscription_type || 0,
      subscription_end_date: profileData.subscription_end_date,
      is_first_login: data.is_first_login,
      account_type: profileData.account_type,
      dot_authorized: profileData.dot_authorized ?? false,
    };
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("user", JSON.stringify(userData));
    
    updateUser(userData);
    if (data.is_first_login || !userData.account_type) {
      navigate("/onboarding", { replace: true }); 
    } else {
      navigate("/", { replace: true });
    }
  };

  useEffect(() => {
    const handleCallback = async () => {
      if (callbackProcessed.current) return;
      callbackProcessed.current = true;

      try {
        const auth = getFirebaseAuth();
        const redirectResult = await getRedirectResult(auth);
        if (redirectResult?.user) {
          const idToken = await redirectResult.user.getIdToken();
          const response = await fetch(`${API_URL}/auth/firebase/login`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id_token: idToken }),
          });
          if (!response.ok) {
            throw new Error("Failed to exchange Firebase token");
          }
          const data = await response.json();
          persistSession(data, data);
          return;
        }

        navigate("/?error=no_code");
        return;
      } catch (error) {
        console.error(
          "Error processing authentication:",
          error.response?.data?.detail || error.message,
        );
        navigate("/?error=auth_failed", { replace: true });
      }
    };

    handleCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, location, updateUser]);

  return (
    <div className="auth-callback">
      <div className="loading-spinner"></div>
      <p>Completing sign in...</p>
    </div>
  );
};

export default AuthCallback;
